import { render, staticRenderFns } from "./DocumentUploadLandlord.vue?vue&type=template&id=490f0396&"
import script from "./DocumentUploadLandlord.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadLandlord.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadLandlord.vue?vue&type=style&index=0&id=490f0396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports